import moment from "moment";
import axios from 'axios';

export const funciones = {
  /**
   * Recibe un numero o string entre 0 y 11, regresa el mes según el arreglo
   **/
  getMes: function(mesString) {
    var mes = parseInt(mesString);
    const meses = ["Enero", "Febrero", "Marzo", "Abril", "Mayo", "Junio", "Julio", "Agosto", "Septiembre", "Octubre", "Noviembre", "Diciembre"];
    if (meses[mes] != undefined)
      return meses[mes];
    else
      return "N/A";
  },

  getLicencia: (self) => {
    return self.$crypto.decrypted(self.$local_storage.get(self.$crypto.SHA256("uuid_licencia")));
  },

  getTiposPrecio: (docClient, id_empresa) => {
    return new Promise(function(resolve, reject) {
      var params = {
        TableName: "empresas",
        Key: {
          uuid: id_empresa,
        },
        AttributesToGet: ['tipos_precio', 'actualizado']
      };
      docClient.get(params, function(err, data) {
        if (err) {
          reject(error);
        } else {
          if (data.Item != undefined && data.Item.tipos_precio != undefined) {
            resolve(data.Item.tipos_precio);
          }
        }
      });
    });

  },

  //nuevaCantidad: es la cantidad a agregar o restar, si es negativa se restará
  //maximoIn y minimoIn: son la cantidad que se queda como maximo/minimo, esta no se suma ni se resta
  afectaInventario: async (docClient, id_licencia, id_producto, nuevaCantidad, maximoIn = "", minimoIn = "") => {
    return new Promise(function(resolve, reject) {
      try {
        var params = {
          TableName: "productos",
          Key: {
            uuid: id_producto,
          },
          AttributesToGet: ['inventario']
        };
        docClient.get(params, function(err, data) {
          if (err) {
            reject(error);
          } else {
            if (data.Item != undefined && data.Item.inventario != undefined) {
              var items = data.Item.inventario;
              const search = (element) => element.uuid_licencia == id_licencia;
              var idx = items.findIndex(search);
              if (idx >= 0) { //Si el producto ya esta en inventario con el mismo no. de licencia se actualiza la cantidad
                items[idx].cantidad = parseFloat(items[idx].cantidad) + parseFloat(nuevaCantidad);
                if (maximoIn != "")
                  items[idx].maximo = parseFloat(maximoIn);
                if (minimoIn != "")
                  items[idx].minimo = parseFloat(minimoIn);
              } else { //Sino se ingresa nuevo
                var item = {
                  cantidad: nuevaCantidad,
                  minimo: minimoIn,
                  maximo: maximoIn,
                  uuid_licencia: id_licencia
                }
                items.push(item);
              }
              var params2 = {
                TableName: "productos",
                Key: {
                  uuid: id_producto,
                },
                AttributeUpdates: {
                  'inventario': {
                    Action: "PUT",
                    /*ADD | PUT | DELETE,*/
                    Value: items
                  },
                },
              };
              docClient.update(params2, function(err, data) {
                if (err) {
                  reject(err);
                } else {
                  resolve(data);
                }
              });
            }
          }
        });
      } catch (error) {
        reject(error);
      }

    });

  },

  getTotalEfectivoVentas: async (docClient, id_empresa, id_licencia) => {
    return new Promise(function(resolve, reject) {
      try {
        var fe = 'uuid_empresa = :e and uuid_licencia = :l';
        var eav = {
          ':e': id_empresa,
          ':l': id_licencia
        };

        var params = {
          TableName: "ventas",
          FilterExpression: fe,
          ExpressionAttributeValues: eav,
        };
        docClient.scan(params, function(err, data) {
          if (err) {
            reject(error);
          } else {
            var result = {
              "keys": [],
              "total": parseFloat(0)
            };
            data["Items"].forEach(function(item) {
              //Se obtienen las ventas en efectivo que no tengan un uuid_corte
              if (item.uuid_corte == undefined || (item.uuid_corte != undefined && item.uuid_corte.toString().trim() == "")) {
                item.forma_pago.forEach(function(forma) {
                  if (forma.tipo == "Efectivo") {
                    result.total += parseFloat(forma.importe);
                    result.keys.push(item.uuid);
                  }
                });
              }
            });
            resolve(result);
          }
        });
      } catch (error) {
        reject(error);
      }
    });
  },

  getTotalSalidasCaja: async (docClient, id_empresa, id_licencia) => {
    return new Promise(function(resolve, reject) {
      try {
        var fe = 'uuid_empresa = :e and uuid_licencia = :l';
        var eav = {
          ':e': id_empresa,
          ':l': id_licencia
        };

        var params = {
          TableName: "caja_salidas",
          FilterExpression: fe,
          ExpressionAttributeValues: eav,
        };
        docClient.scan(params, function(err, data) {
          if (err) {
            reject(error);
          } else {
            var result = {
              "keys": [],
              "total": parseFloat(0)
            };
            data["Items"].forEach(function(item) {
              //Se obtienen las ventas en efectivo que no tengan un uuid_corte
              if (item.uuid_corte == undefined || (item.uuid_corte != undefined && item.uuid_corte.toString().trim() == "")) {
                result.total += parseFloat(item.cantidad);
                result.keys.push(item.uuid);
              }
            });
            resolve(result);
          }
        });
      } catch (error) {
        reject(error);
      }
    });
  },

  getImporteCajaAnterior: async function(items) {
    return new Promise(function(resolve, reject) {
      try {
        var total = parseFloat(0);
        var ultimo = null;
        if (items.length > 0) {
          ultimo = items.reduce((a, b) => {
            return new Date(a.fecha) > new Date(b.fecha) ? a : b;
          });
          if (ultimo != null)
            total += parseFloat(ultimo.importe_caja);
          //console.log(ultimo);
        }
        resolve(total)
      } catch (error) {
        reject(error);
      }
    });

  },

  setCorteCaja: async (docClient, id_empresa, id_licencia, id_corte, ventasArray, salidasArray) => {
    return new Promise(function(resolve, reject) {
      try {
        /////////////////////
        var params = {
          TransactItems: []
        };

        ventasArray.forEach(function(element) {
          var actualizar = {
            Update: {
              TableName: 'ventas',
              Key: {
                uuid: element
              },
              UpdateExpression: 'set uuid_corte = :id_corte',
              ConditionExpression: 'uuid_corte = :vacio and uuid_empresa = :e and uuid_licencia = :l',
              //ExpressionAttributeNames: {'#a' : 'uuid_corte'},
              ExpressionAttributeValues: {
                ':id_corte': id_corte,
                ':vacio': "",
                ':e': id_empresa,
                ':l': id_licencia,
              }
            }
          }
          params.TransactItems.push(actualizar);
        });

        salidasArray.forEach(function(element) {
          var actualizar = {
            Update: {
              TableName: 'caja_salidas',
              Key: {
                uuid: element
              },
              UpdateExpression: 'set uuid_corte = :id_corte',
              ConditionExpression: 'uuid_corte = :vacio and uuid_empresa = :e and uuid_licencia = :l',
              //ExpressionAttributeNames: {'#a' : 'uuid_corte'},
              ExpressionAttributeValues: {
                ':id_corte': id_corte,
                ':vacio': "",
                ':e': id_empresa,
                ':l': id_licencia,
              }
            }
          }
          params.TransactItems.push(actualizar);
        });

        if (params.TransactItems.length > 0) {
          docClient.transactWrite(params, function(err, data) {
            if (err) {
              reject(err);
            } else {
              resolve(true);
            }
          });
        } else
          resolve(true);

      } catch (error) {
        reject(error);
      }
    });
  },

  update_last_action: (docClient, uuid_usuario) => {
    if (uuid_usuario == "" || uuid_usuario == null || uuid_usuario == undefined) {
      return;
    }

    return new Promise(function(resolve, reject) {
      var params = {
        TableName: 'usuarios',
        Key: {
          "uuid": uuid_usuario
        },
        UpdateExpression: "set ultimo_movimiento = :u",
        ExpressionAttributeValues: {
          ":u": Date.now()
        },
        ReturnValues: "UPDATED_NEW"
      };

      docClient.update(params, function(err, data) {
        if (err) {
          reject('error');
        } else {
          resolve(true)
        }
      });
    });
  },

  enviar_email: async function(self, docClient, asunto, bodyText, bodyHtml, destinatariosArr, adjuntosArr = []) {
    return new Promise(function(resolve, reject) {
      var item = {};
      item.uuid = self.$uuid.v4();
      item.fecha = moment().format('YYYY-MM-DD HH:mm:ss');
      item.nombre_usuario = self.$crypto.decrypted(self.$local_storage.get(self.$crypto.SHA256("nombre_usuario")));
      item.uuid_usuario = self.$crypto.decrypted(self.$local_storage.get(self.$crypto.SHA256("uuid_usuario")));
      item.uuid_empresa = self.$crypto.decrypted(self.$local_storage.get(self.$crypto.SHA256("uuid_empresa")));
      item.uuid_licencia = self.$crypto.decrypted(self.$local_storage.get(self.$crypto.SHA256("uuid_licencia")));
      item.asunto = asunto;
      item.body_text = bodyText;
      item.body_html = bodyHtml;
      item.destinatarios = destinatariosArr; //a quienes se envía el correo
      item.key_s3 = adjuntosArr;

      var params = {
        TableName: "correos",
        Item: item,
      };
      docClient.put(params, function(err, data) {
        if (err) {
          console.log(err);
          reject(err);
        } else {
          resolve(true);
        }
      });
    });
  },

  get_saldo: function(uuid_empresa) {
    return new Promise(async function(resolve, reject) {
      var params = {
        filtros: {
          uuid: uuid_empresa
        }
      };

      await axios.post("https://ozu2hub36m.execute-api.us-east-1.amazonaws.com/dev/carta_porte/administracion/list_empresas/", params)
        .then(res => {
          if (typeof res.data !== "undefined") {
            resolve(res.data[0]['saldo']);
          }
        })
        .catch(err => {
          reject(err);
        });
    });
  }
}
